module.exports = __webpack_public_path__ + "img/avatar.1958f082.png";